import React from 'react';
import Divider from '@amzn/meridian/divider';
import MultipleChoiceQuestion from './MultipleChoiceQuestion';
import TextQuestion from './TextQuestion';
import QuestionTypes from '../enums/QuestionTypes';
import StarRating from './StarRating';
import { TEXT_QUESTION_RESPONSE_CHAR_LIMIT } from '../constants/FeedbackConstants';

const RequiredQuestionTypeComponent = ({
  question: { questionText, questionId, isMandatory, questionType },
  prePopulatedValue,
}) => {
  let requiredComponent = null;

  switch (Object.keys(questionType)[0]) {
    case QuestionTypes.MULTIPLE_CHOICE_QUESTION:
      requiredComponent = (
        <>
          <MultipleChoiceQuestion
            question={questionText}
            id={questionId}
            isMandatory={isMandatory}
            functionalities={questionType.multipleChoiceQuestionType.options}
          />
          <Divider size="small" />
        </>
      );
      break;
    case QuestionTypes.RATING_QUESTION:
      requiredComponent = (
        <>
          <StarRating
            question={questionText}
            id={questionId}
            isMandatory={isMandatory}
            minRatingValue={questionType.ratingQuestionType.minRatingValue}
            ratingInterval={questionType.ratingQuestionType.ratingInterval}
            numberOfIntervals={
              questionType.ratingQuestionType.numberOfIntervals
            }
          />
          <Divider size="small" />
        </>
      );
      break;
    case QuestionTypes.TEXT_QUESTION:
      requiredComponent = (
        <>
          <TextQuestion
            question={questionText}
            id={questionId}
            isMandatory={isMandatory}
            limit={
              questionType.textQuestionType.charLimit ||
              TEXT_QUESTION_RESPONSE_CHAR_LIMIT
            }
            prePopulatedValue={prePopulatedValue}
          />
          <Divider size="small" />
        </>
      );
      break;
    default:
      requiredComponent = <></>;
      break;
  }
  return requiredComponent;
};

export default RequiredQuestionTypeComponent;
